import { Subject, merge } from 'rxjs'
import React, { Component } from 'react'
import { ReactSVG } from 'react-svg'
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/functions'
import 'firebase/compat/firestore'
import 'firebase/compat/storage'
import { BnSplash } from '../Splash'
import { BnApp } from '../App'
import { Me } from '../../classes/Me'
import { isIPad, isAndroid, isWindows, isSafari, isDesktop, isMobile, isIOS } from '../../classes/Platform.js'
import './index.css'

let portalRef

export const getPortal = () => {
  if (window.getPortalRef) return window.getPortalRef()
  if (portalRef) return portalRef
  return null
}
const firebaseConfig = {
  apiKey: "AIzaSyBvpeSaIwoFaZp56DH_A4N02qIMm2dXP2Y",
  authDomain: "attunewisetechdemo.web.app",
  projectId: "attunewisetechdemo",
  storageBucket: "attunewisetechdemo.appspot.com",
  messagingSenderId: "80135616279",
  appId: "1:80135616279:web:c6694527640d5589dfe952"
};

const getEnv = () => 'prod'

const getFirebaseConfig = () => {
  return firebaseConfig
}

const config = getFirebaseConfig()

console.log('firebaseConfig', config)
firebase.initializeApp(config)

const me = new Me(firebase, config)

export class BnClient extends Component {
  constructor (props) {
    super(props)
    this.state = {
    }
  }

  componentDidMount() {
    me.observeSelf().subscribe(self => {
      this.setState({self})
      if (false && !self) {
        me.nativeLogin()
      }
    })
  }

  setPortalRef = ref => {
    if (ref) {
      portalRef = ref
      this.forceUpdate()
    }
  }

  getPlatform = () => {
    let bxPlatName = 'bnClient'

    if (isMobile()) {
      bxPlatName += ' benxtAppMobile'
    }

    if (isIOS()) {
      bxPlatName += ' benxtAppIOS'
    }

    if (isAndroid()) {
      bxPlatName += ' benxtAppAndroid'
    }

    if(isDesktop() || isIPad()) {
      bxPlatName += ' benxtAppDesktop'
    }

    if (isSafari()) {
      bxPlatName += ' benxtAppSafari'
    }
    
    if (isWindows()) {
      bxPlatName += ' benxtAppWindows'
    }

    if (me.isNative()) {
      bxPlatName += ' benxtAppNative'
    } else {
      bxPlatName += ' benxtAppWeb'
    }

    return(bxPlatName);
  }

  render () {
    const self = this.state.self
    return <div className={this.getPlatform()} ref={this.setPortalRef}>
        <BnApp self={self} me={me}/>
    </div>
  }
}
